import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DocumenteComponent } from './documente.component';

const routes: Routes = [
    {
        path: '',
        component: DocumenteComponent,
        data: {
            title: 'Documente'
        }
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class DocumenteRoutingModule { }
